import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../services/auth.service";
import { ScreenSizeService } from "src/app/services/screen-size.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {
  username: string = "";
  password: string = "";
  email: string = "";
  loginError: string = "";
  resetSuccess: boolean = false;
  resetMode: boolean = false; // Determines whether we're in reset password mode

  isMobile: boolean;
  isDesktop: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private screenSizeService: ScreenSizeService
  ) {}

  ngOnInit(): void {
    document.body.classList.add("login-background");
    this.screenSizeService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
    this.screenSizeService.isDesktop$.subscribe((isDesktop) => {
      console.log("IsDeskTop: " + isDesktop);
      this.isDesktop = isDesktop;
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove("login-background");
  }

  // Modify onSubmit to use async/await for login
  async onSubmit(): Promise<void> {
    try {
      await this.authService.login(this.username, this.password); // Await the login promise
      this.router.navigate(["/home"]);
    } catch (error) {
      console.error("Login failed", error);
      const msg =
        (error as any)?.error?.detail ||
        (error as any)?.error?.message ||
        (error as any)?.error ||
        (error as any)?.message ||
        "Login failed. Please check your credentials and try again.";
      this.loginError = typeof msg === "string" ? msg : JSON.stringify(msg);
    }
  }

  // Modify onResetSubmit to handle async resetPassword method
  async onResetSubmit(): Promise<void> {
    try {
      await this.authService.resetPassword(this.email); // Await the resetPassword promise
      this.resetSuccess = true;
      this.resetMode = false;
      this.email = "";
    } catch (error) {
      this.loginError = "Failed to submit reset password request.";
      console.error("Reset password failed", error);
    }
  }

  passwordVisible: boolean = false;
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  switchToReset() {
    this.resetMode = true;
    this.loginError = "";
    this.resetSuccess = false;
  }

  switchToLogin() {
    this.resetMode = false;
    this.loginError = "";
    this.resetSuccess = false;
  }
}
